/* Premium Blog — scroll reveal, reading progress, table of contents, copy link. */
(function () {
  'use strict';

  function initReveal(root) {
    var items = root.querySelectorAll('.pb-reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 0.08 + 's';
      io.observe(el);
    });
  }

  function initProgress(root) {
    var bar = root.querySelector('.pb-progress');
    var body = root.querySelector('.pa-content');
    if (!bar || !body) return;
    var ticking = false;
    function update() {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight * 0.6;
      var done = Math.min(Math.max(-rect.top + window.innerHeight * 0.2, 0), Math.max(total, 1));
      bar.style.transform = 'scaleX(' + (done / Math.max(total, 1)) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function slug(text, used) {
    var base = text.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').slice(0, 60) || 'section';
    var id = base, n = 2;
    while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
    used[id] = true;
    return id;
  }

  function initToc(root) {
    var toc = root.querySelector('.pa-toc');
    var list = toc && toc.querySelector('ol');
    var body = root.querySelector('.pa-content');
    var layout = root.querySelector('.pa-layout');
    if (!toc || !list || !body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
    if (headings.length < 2) {
      if (layout) layout.classList.add('pa-layout--no-toc');
      return;
    }

    var used = {};
    var links = headings.map(function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'is-sub';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });

    if (!('IntersectionObserver' in window)) return;
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
      var active = null;
      for (var i = 0; i < headings.length; i++) {
        if (visible[headings[i].id]) { active = i; break; }
      }
      if (active === null) return;
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
    }, { rootMargin: '-100px 0px -65% 0px' });
    headings.forEach(function (h) { io.observe(h); });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-pb-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-pb-copy');
        var done = function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(done, function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = url;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.pbReady) return;
    root.dataset.pbReady = '1';
    initReveal(root);
    initProgress(root);
    initToc(root);
    initCopy(root);
  }

  function initAll() { document.querySelectorAll('.pb').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.pb')); });
})();
